import { useContext, useId } from 'react';
import { FormattedMessage } from 'react-intl';

import { Flex } from '@dynatrace/strato-components/layouts';
import { Text } from '@dynatrace/strato-components/typography';

import { CodeSnippet } from '../../../content/code-snippet/CodeSnippet.js';
import { InformationOverlay } from '../../../overlays/information-overlay/InformationOverlay.js';
import { NotificationSettingsContext } from '../contexts/NotificationSettingsContext.js';
import { notificationMessages } from '../messages.js';

/** @internal */
export function NotificationPermissionInfo() {
  const { hasReadPermission, enabled } = useContext(
    NotificationSettingsContext,
  );

  const informationOverlayContentId = useId();

  if (hasReadPermission) {
    return null;
  }

  return (
    <InformationOverlay aria-labelledby={informationOverlayContentId}>
      <InformationOverlay.Trigger />
      <InformationOverlay.Content id={informationOverlayContentId}>
        <Flex flexDirection="column">
          <Flex flexDirection="column" gap={0}>
            <Text textStyle="base-emphasized">
              <FormattedMessage
                {...notificationMessages.noPermissionsHeading}
                values={{
                  notificationEnabled: enabled,
                }}
              />
            </Text>
            <Text textStyle="base">
              <FormattedMessage {...notificationMessages.copyPermissions} />:
            </Text>
          </Flex>
          <CodeSnippet showLineNumbers={false} language="json" lineBreaks>
            notification:notifications:read
          </CodeSnippet>
        </Flex>
      </InformationOverlay.Content>
    </InformationOverlay>
  );
}
